module.exports = __webpack_public_path__ + "static/media/video.3a314866.jpg";